module.exports = __webpack_public_path__ + "app/modals/move-to-customer-modal.html";